'use strict'
//import Vimeo from '@vimeo/player';

export default class Research {
    constructor() {
        this.content = $('.contentResearch');
        this.createEvents();
        this.hide();
    }
    createEvents() {
        this.content.find('.btn_content').each((i,e) => {
            $(e).click(() => {
                const part = $(e).attr('data-target-index');
                window.staticEvents.emit('navigate',`research/${part}`);
                //this.show(part);
            });
        });
        this.content.find('a').each((i,e) => {
            $(e).click((el) => {
                window.staticEvents.emit('trackEvent',['research','open',`${$(el.currentTarget).attr('href')}`]);
            });
        });
    }
    hide() {
        this.content.detach();
    }
    show(index) {
        this.content.insertBefore('.questions');
        this.content[0].style.display = 'flex';
        const targetClass = `research_${index}`; 
        const targets = this.content.find(`.research_s.${targetClass}`);
        const nonTargets = this.content.find(`.research_s:not(.${targetClass})`);
        const speed1 = 0;
        const speed2 = 550;
        targets.show();
        nonTargets.hide();
        this.content.find('.sub2_s.last').removeClass('last');
        targets.last().addClass('last');
        $('.sub1_s').removeClass('active');
        $(`.sub1_s.sub1_${index}`).addClass('active');
    }
}
